import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

/**
 * Format exam acquisition dates from ISO (YYYY-MM-DD) or DICOM (YYYYMMDD).
 * Returns '-' when the value is missing or unparseable.
 */
export function formatExamAcquisitionDate(date?: string | null): string {
  if (!date?.trim()) {
    return '-'
  }

  const parsed = dayjs(date, ['YYYY-MM-DD', 'YYYYMMDD'], true)
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : '-'
}
